import reviewCountTransformer from './reviewCountTransformer';
import transformDoubleChart from './doubleChartTransformer';
import visitTransformer from './visitTransformer';
import installHealthTransformer from './installHealthTransformer';
import { transformSeries } from './utils';

function defaultTransformer({ primaryChart: chart }) {
  const series = transformSeries(chart);
  return { series, options: {} };
}

const specificTransformers = {
  review_count: reviewCountTransformer,
  visit: visitTransformer,
  installation_health_report: installHealthTransformer,
};

function getSingleChartTransformer(chart) {
  const { name } = chart;
  const specificTransformer = specificTransformers[name];
  return specificTransformer || defaultTransformer;
}

function getTransformer(primaryChart, secondaryChart) {
  if (primaryChart && secondaryChart) return transformDoubleChart;
  return getSingleChartTransformer(primaryChart);
}

export default function({
  primaryChart,
  secondaryChart,
  chartsConfig,
  sameScale = false,
}) {
  primaryChart.title = chartsConfig[primaryChart.name]
    ? chartsConfig[primaryChart.name].title
    : null;

  if (secondaryChart) {
    secondaryChart.title = chartsConfig[secondaryChart.name]
      ? chartsConfig[secondaryChart.name].title
      : null;
  }
  const transformer = getTransformer(primaryChart, secondaryChart);
  const { options, series } = transformer({
    primaryChart,
    secondaryChart,
    sameScale,
  });
  return { options, series };
}
